import { Link } from "react-router-dom";

const BlogList = ({blogs, title, handleDelete }) => {
    // const blogs = props.blogs;
    // const title = props.title;
    return ( 
        <div className="blog-list">
            <h2>{title}</h2>
            {blogs.map((blog) =>(
                <div className="blogPreview" key={blog.id}>
                    <Link to={`/blogs/${blog.id}`}>
                        <h2>{blog.title}</h2>
                        <p>{blog.body}</p>
                    </Link>
                    <p>Written by <strong>{blog.author}</strong></p>
                    {/* <button onClick={ ()=>handleDelete(blog.id) } >Delete</button> */}
                </div>
            ) )}
        </div>
     );
}
 
export default BlogList;